<template>
  <div>
    <popup-hint hint="packing">
      <template v-slot:breadcrumbs>
        <breadcrumbs home="Mixed-pack packing">

          <template v-slot:right>
            <v-menu offset-y v-if="company.permissions.includes('config.write')" :close-on-content-click="false" nudge-bottom="5" left max-width="500">
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on">mdi-tune-variant</v-icon>
              </template>
              <production-packing-preferences/>
            </v-menu>
          </template>
        </breadcrumbs>
      </template>
      <template v-slot:top>
        Packing operations are recorded and managed here.
      </template>
    </popup-hint>

    <purtrak-table name="packing" objectType="packings" :defaultColumns="defaultColumns" :headers="headers" ref="table" show-select show-expand
                   listEndPoint="packings" v-model="selected" @list="listBuilt"
                   fields="id,date,number,productId,productName,lot,comments,value,dutyPaid,packs,cases"
                   totalFields="totalPacks,totalCases,totalValue"
                   :totals.sync="totals"
                   :listFilters="listFilters"
                   @dblclick="packing => $router.push({name:'ProductionPackingEdit',params:{packingId:packing.id}})"
                   @itemExpanded="({item, value}) => expandPacking(item, value)"
                   title="Packing"
                   :print-info="{pageSize:'landscape',
                                 subTitle:[filters.from?dateDisplay:'',filters.productId!=null?productName:'']}"
                   download-endpoint="packingsExportCSV">
      <template v-slot:filter>
        <scan-code @code="scan" auto-close :products="products"/>
        <filter-menu include-reset @reset="filters.completeStatus=null;filters.productId=null;filters.from=null;filters.to=null;categoryId=null;filters.lot='';filters.number=''">
          <v-list-item>
            <filter-search label="Lot" v-model="filters.lot"/>
          </v-list-item>
          <v-list-item>
            <filter-search label="Number" v-model="filters.number"/>
          </v-list-item>
          <v-list-item>
            <date-range :from.sync="filters.from" :to.sync="filters.to" v-model="dateDisplay" option="All" allow-all/>
          </v-list-item>
          <v-list-item>
            <multi-level-select v-if="!!categories" label="Product" :menuData="categories" :first.sync="categoryId" :second.sync="filters.productId" outlined no-validation/>
            <v-autocomplete v-else label="Product" dense outlined :items="products" item-value="id" item-text="name" v-model="filters.productId"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.lot" close small class="ml-1" @click:close="filters.lot=''">Lot: {{filters.lot}}</v-chip>
          <v-chip v-show="filters.number!=''" close small class="ml-1" @click:close="filters.number=''">#: {{filters.number}}</v-chip>
          <v-chip v-show="filters.from!=null" close small class="ml-1" @click:close="filters.from=null;filters.to=null">{{dateDisplay}}</v-chip>
          <v-chip v-show="filters.productId" close small class="ml-1" @click:close="filters.productId=null;categoryId=null">{{productName}}</v-chip>
        </template>
      </template>
      <template v-slot:menu>
        <template v-if="!readOnly">
          <v-list-item :to="{name:'ProductionPackingEditNew'}"><v-list-item-title>Create mixed-pack packing</v-list-item-title></v-list-item>
        </template>
      </template>

      <template v-slot:footer v-if="selected.length">
        <v-icon style="position: absolute" class="mt-3 ml-3">mdi-arrow-up-left</v-icon>
        <v-menu offset-y top>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" outlined x-small style="position: absolute" class="mt-5 ml-10" v-on="on">Batch commands</v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="printPackingBatch()"><v-list-item-title>Print</v-list-item-title></v-list-item>
            <v-divider/>
            <v-list-item @click="deleteMultiple=true;showDelete=true"><v-list-item-title>Delete</v-list-item-title></v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:item.date="{item,value,printing}">
        {{item.date | formatDateTime}}
      </template>
      <template v-slot:item.productName="{item,printing}">
        {{item.productName}}
        <div class="text-caption" v-if="!printing">{{item.comments}}</div>
      </template>
      <template v-slot:item.dutyPaid="{value,printing}">
        <template v-if="printing">{{value?'Y':''}}</template>
        <v-icon v-else-if="value">mdi-check</v-icon>
      </template>
      <template v-slot:item.value="{value}">
        {{value | currency}}
      </template>
      <template v-slot:item.packs="{value}">
        {{value | number(0)}}
      </template>
      <template v-slot:item.cases="{value}">
        {{value | number(1)}}
      </template>
      <template v-slot:item.lot="{item,value,printing}">
        <template v-if="printing">{{value}}</template>
        <v-hover v-else-if="item.lot" v-slot="{hover}">
          <a @click.stop="$router.push({name:'ReportsView',params:{back:[{text:'Packing',to:{name:'ProductionPacking'}}]},query:{to:'reports/inventory/ReportsLot',id:item.id,lot:item.lot,forward:0}})"
             :class="{'text-decoration-underline':hover}">{{item.lot}}</a>
        </v-hover>
      </template>
      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small :to="{name:'ProductionPackingEditNew'}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Packing operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item :to="{name:'ProductionPackingEdit',params:{packingId:item.id}}"><v-list-item-title>Details</v-list-item-title></v-list-item>
            <!--
            <v-list-item @click="printPacking(item.id,null,true)"><v-list-item-title>Print</v-list-item-title></v-list-item>
            -->
            <generate-qr-code type="Product" :id="item.productId" ask-quantity quantityUnits="cases" cases ask-lot :lots="[item.lot]"/>
            <v-divider/>
            <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Packing',to:{name:'ProductionPacking'}}]},query:{to:'reports/inventory/ReportsLot',id:item.id,lot:item.lot,forward:0}}"><v-list-item-title>Trace lot</v-list-item-title></v-list-item>
            <v-list-item v-if="audit" :to="{name:'Audit',query:{entityId:item.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
            <template v-if="!readOnly">
              <v-divider/>
              <v-list-item @click="updateComments(item)"><v-list-item-title>Update comments</v-list-item-title></v-list-item>
              <v-list-item @click="packing=item;deleteMultiple=false;showDelete=true"><v-list-item-title>Delete packing</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:body.append="{headers,printing}" v-if="!$vuetify.breakpoint.mobile">
        <tr :class="darkMode ? 'total-row-dark' : 'total-row'">
          <template v-for="header of headers">
            <td class="text-right" v-if="header.value==='bottles'">
              {{totals.totalPacks | number(0)}}
            </td>
            <td class="text-right" v-else-if="header.value==='cases'">
              {{totals.totalCases | number(1)}}
            </td>
            <td class="text-right" v-else-if="header.value==='value' && values">
              {{totals.totalValue | currency}}
            </td>
            <td v-else-if="!printing || header.print === undefined || header.print"/>
          </template>
        </tr>
      </template>
      <template v-slot:expanded-item="{ headers,item }">
        <td :colspan="headers.length">
          <v-card class="my-4" :class="expansionPanelClass">
          <v-simple-table dense class="pl-16 text-caption" :class="expansionPanelClass" style="width:70%">
            <thead>
              <tr>
                <th :class="expansionPanelClass" width="40%">BOM</th>
                <th :class="expansionPanelClass" width="10%">Lot</th>
                <th class="text-right" :class="expansionPanelClass" width="30%">Quantity</th>
                <th class="text-right" :class="expansionPanelClass" width="20%" v-if="values">Value</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(packingItem,index) of item.items" :key="index">
                <td class="text-caption">{{packingItem.name}}</td>
                <td class="text-caption">
                  <a @click="$router.push({name:'ReportsView',params:{back:[{text:'Packing',to:{name:'ProductionPacking'}}]},query:{to:'reports/inventory/ReportsLot',id:packingItem.id,lot:packingItem.lot,forward:0}})">{{packingItem.lot}}</a>
                </td>
                <td class="text-caption text-right">{{packingItem.quantity | number(packingItem.precision)}} {{packingItem.units}}</td>
                <td class="text-caption text-right" v-if="values">{{packingItem.value | currency}}</td>
              </tr>
            </tbody>
          </v-simple-table>
          </v-card>
        </td>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" :name="deleteMultiple?'ALL selected packings':'this packing'" @delete="performDelete(packing.id)"/>
    <component :is="dialog" v-bind="dialogProperties" @done="dialog = null"/>
  </div>
</template>

<script>
import performDelete from '@/mixins/performDelete'
import createHierarchyList from '@/mixins/createHierarchyList'
import googleCharts from '@/mixins/googleCharts'
import {format,add} from 'date-fns'
import productionPackingPrintPacking from '@/views/production/packing/productionPackingPrintPacking'
import ProductionPackingPreferences from '@/views/production/packing/ProductionPackingPreferences'
import generateQrCode from '@/components/GenerateQrCode'

export default {
  name: 'ProductionPacking',
  mixins: [createHierarchyList,productionPackingPrintPacking,googleCharts,performDelete],
  components: {ProductionPackingPreferences,generateQrCode},
  data() {
    return {
      incompleteCount: 0,
      showStatus: false,
      filters: {
        number: '',
        from: null,
        to: null,
        future: '1',
        productId: null,
        completeStatus: null,
        lot: '',
        percentTolerance: 0,
        laaTolerance: 0
      },
      categoryId: null,
      dateDisplay: '',
      packing: {},
      products: [],
      categories: null,
      totals: {
        totalValue: 0,
        totalBottles: 0,
        totalCases: 0,
        totalPallets: 0,
        totalLAA: 0,
        totalLitres: 0
      },
      showDelete: false,
      deleteMultiple: false,
			dialog: null,
      dialogProperties: {},
      graphFrom: '',
      graphTo: '',
      graph: null,
      showGraph: false,
      defaultColumns: [{ value: 'date', visible:true},
                       { value: 'number', visible:true},
                       { value: 'productName', visible:true},
                       { value: 'comments', visible:false},
                       { value: 'lot' ,visible:true},
                       { value: 'dutyPaid' ,visible:false},
                       { value: 'cases', visible:false},
                       { value: 'packs', visible:true},
                       { value: 'value', visible:true}],
      headers: [{ text: 'DATE', value: 'date', width:'15%',sortable:true},
                { text: '#', value: 'number', width:'10%',sortable:true},
                { text: 'PRODUCT', value: 'productName', width:'25%',sortable:true},
                { text: 'COMMENTS', value: 'comments', width:'25%',sortable:false},
                { text: 'LOT', value: 'lot', width:'10%',sortable:true},
                { text: 'DUTY PAID?', value: 'dutyPaid', width:'10%',sortable:true,align:'center'},
                { text: 'PACKS', value: 'packs', width:'15%',sortable:true,align:'right'},
                { text: 'CASES', value: 'cases', width:'15%',sortable:true,align:'right'},
                { text: 'VALUE', value: 'value', width:'15%',sortable:true,align:'right', omit:() => !this.values}]
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    readOnly() {
      return !this.company.permissions.includes('production.write');
    },
    values() {
      return this.company.permissions.includes('values');
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    },
    productName() {
      return this.products.find(product => product.id === this.filters.productId)?.name;
    },
    listFilters() {
      const filters = [];
      if (this.filters.number)
        filters.push({field:'number', comparator:'contains', value:this.filters.number});
      if (this.filters.lot)
        filters.push({field:'lot', comparator:'eq', value:this.filters.lot});
      if (this.filters.from)
        filters.push({field:'date', comparator:'ge', value:`${this.filters.from} 00:00:00`});
      if (this.filters.to)
        filters.push({field:'date', comparator:'le', value:`${this.filters.to} 23:59:59`});
      if (this.filters.productId)
        filters.push({field:'productId', comparator:'eq', value:this.filters.productId});
      return filters;
    }
  },
  async created() {
    this.$store.dispatch('checkTasks');
    this.loading = true;
    const categoriesList = [];
    await Promise.all([
      this.$lazyListLoad(categoriesList, 'categories2', 'id,name,parent{id}', 100, [], [{name:'type',value:'Product'}]),
      this.$lazyListLoad(this.products, 'products2', 'id,upc,scc,name,category{id}', 100, [{field:'active', comparator:'eq', value:'true'},{field:'mixedPack', comparator:'eq', value:'true'}])
    ]);
    if (categoriesList.length) {
      const categories = this.createHierarchyList(categoriesList);
      for (const category of categories) {
        const sub = this.products.filter(product => product.category?.id === category.id);
        if (sub.length)
          category.menu = sub;
        else
          category.disabled = true;
      }
//        this.categories = [{name:'All products',id:null},{divider:true},...categories.filter(category => !category.disabled)];
      this.categories = [{name:'All products',id:null},{divider:true},...categories];
      const leftOver = this.products.filter(product => !product.category?.id);
      if (leftOver.length)
        this.categories.push({divider:true},{name:'Other products',id:'x',menu:leftOver});
    }
    else
      this.products = [{name:'All products',id:null},{divider:true}, ...this.products];
    this.loading = false;

    if (!['ProductionPackingEdit', 'ProductionPackingEditNew'].includes(this._previousRoute) &&
        Object.keys(this.$route.query).length === 0 &&
        this.incompleteCount && !localStorage.getItem('hideNotification')) {
      this.$nextTick(() => this.showStatus = true);
      setTimeout(() => this.showStatus = false, 10_000);  // Close in 10 seconds
    }
  },
  methods: {
    scan({type, id, lot}) {
      if (type === 'Product')
        Object.assign(this.filters, {completeStatus:null,productId:id,from:null,to:null,categoryId:null,lot});
    },
    async listBuilt({list}) {
      if (this.filters.productId && list.edges.length === 1) {
        const packing = list.edges[0].node;
        await this.expandPacking(packing, true);
        this.$refs.table.expanded.push(packing);
      }
    },
    async expandPacking(item, value) {
      if (value && !item.items) {
        this.loading = true;
        const results = await this.$apiCall(`query ProductionPacking($id:ID!) {
                                                  packing(id:$id) {
                                                    bom{name,id,quantity,units,value,lot,precision}
                                                    products{name,id,quantity,value,lot}
                                                  }
                                                }`,
                                            {id:item.id});
        const packing = results.data.packing;
        packing.products.forEach(product => Object.assign(product, {units:'bottles',precision:0}));
        this.$set(item, 'items', [...packing.products,...packing.bom]);
        this.loading = false;
      }
    },
    updateComments(packing) {
      this.dialogProperties = {item:packing, operation:'packingUpdateComments'};
      this.dialog = () => import(`@/views/production/ProductionUpdateComments`);
    },
    async printPackingBatch() {
      const lines = [];
      let n = this.selected.length;
      for (const packing of this.selected) {
        lines.push(... await this.printPacking(packing.id, null, false));
        if (--n)
          lines.push(`<div class="page-break"/>`);
      }
      this.printHtml('Packing',lines.join(''));
    }
  }
}
</script>